module.exports = __webpack_public_path__ + "img/card-text.4bf5afe4.svg";